import { Controller } from "@hotwired/stimulus"
import $ from 'jquery';
//import "vis-timeline/styles/vis-timeline-graph2d.css";

export default class extends Controller {
  static targets = [ "chart", "visualization" ]


  connect () {
    const connection = this.connection = Symbol();
    let _this = this,
        filter = "";

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    filter = urlParams.get('f');

    Promise.all([
      import("vis-timeline/standalone"),
      fetch("/en/calendar.json?f=" + filter).then(data => {
        if (!data.ok) throw new Error("Could not load calendar data");
        return data.json();
      })
    ])
    .then(([{ DataSet, Timeline }, json]) => {
      if (this.connection !== connection) return;
     
      // Create a DataSet (allows two way data-binding)
      var items = new DataSet(json.chart);

      // Configuration for the Timeline
      var options = {
        start: new Date(new Date().getFullYear(), 0, 1), 
        end: new Date(new Date().getFullYear(), 12, 31),
        max: new Date(new Date().getFullYear(), 12, 31),
        min: new Date(2017, 0, 1),
        zoomable: false,
        maxHeight: 800,
        minHeight: 200,
        zoomMin: 100000000,
        //cluster: true,
        interaction: {
          navigationButtons: true
        },
        xss: {
          disabled: true,
          // filterOptions: {
          //   whiteList: { p: ['class', 'data-from-template'], div: 'class' },
          // },
        },
      };
      ///var options = {};
      // Create a Timeline
      this.timeline = new Timeline(_this.visualizationTarget, items, options);

      this.timeline.on('select', function (properties) {
        //console.log('selected event: ' + properties.items);
        if (properties.items.length > 0) {
          $("#sessions").html("<div class='loader'></div>");
          fetch("/en/sessions?event_id=" + properties.items)
          .then(async response => {
            const html = response.ok ? await response.text() : "";
            if (_this.connection !== connection) return;
            
            if (response.ok) {
              //console.log('selected sessions: ', html);
              $("#sessions").html(html);

              $(".session-card .show_program").on("click", function () {
                var program = $(this).parent().parent().parent().find(".program");
                if (program.hasClass("active")) {
                  program.removeClass("active");
                } else {
                  program.addClass("active");
                  $('html,body').animate({ scrollTop: program.offset().top - 100}, 500, function () {
                  });
                }
              });
            } else
              $("#sessions").html("");
          });
        }
      });
    }).catch(() => {
      if (this.connection === connection) window.alert("Could not load calendar. Please reload the page to try again.");
    });
  }

  disconnect() {
    this.connection = null;
    this.timeline?.destroy();
    this.timeline = null;
  }

  zoomIn(event) {
    this.timeline?.zoomIn(0.3);
  }

  zoomOut(event) {
    this.timeline?.zoomOut(0.3);
  }

}
